const topbar = {
    docs: 'Dokumente',
    help: 'Hilfe',
};
export default Object.freeze(topbar);
